export default __webpack_public_path__ + "static/media/monthly.2a8665b0.svg";